<mat-toolbar class="subtitulo">Transferência de Valores</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formulario="ngForm">

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                <div ngModelGroup="comboContaBancariaOrigem" fxFlex="50%" fxLayoutGap="20px" fxFlexOffset="20px" class="marginCombo">
                    <combo-pesquisavel #comboContaBancariaOrigem 
                                        nome="contaBancariaOrigem" 
                                        [itens]="comboContasBancarias" 
                                        itemDescricao="descricaoCompleta"
                                        itemId="id"
                                        label="Conta Bancária - Origem"
                                        placeholder="Escolha..."
                                        [(valor)]="filtro.contaBancariaOrigem"
                                        style="margin-top: 10px;">
                    </combo-pesquisavel>
                </div> 

                <div ngModelGroup="comboContaBancariaDestino" fxFlex="50%" fxLayoutGap="20px" fxFlexOffset="20px" class="marginCombo">
                    <combo-pesquisavel #comboContaBancariaDestino 
                                        nome="contaBancariaDestino" 
                                        [itens]="comboContasBancarias" 
                                        itemDescricao="descricaoCompleta"
                                        itemId="id"
                                        label="Conta Bancária - Destino"
                                        placeholder="Escolha..."
                                        [(valor)]="filtro.contaBancariaDestino"
                                        style="margin-top: 10px;">
                    </combo-pesquisavel>
                </div> 
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                <mat-form-field fxFlex="150px" fxLayoutGap="20px" fxFlexOffset="20px">
                    <input matInput name="dataTransferencia"
                            [matDatepicker]="dataTransferencia" 
                            placeholder="Data" 
                            [(ngModel)]="filtro.dataTransferencia"
                            (input)="onMascaraDataInput($event)">
                    <mat-datepicker-toggle matSuffix [for]="dataTransferencia"></mat-datepicker-toggle>
                    <mat-datepicker #dataTransferencia></mat-datepicker>
                </mat-form-field>

                <mat-form-field fxFlex="150px">
                    <input [(ngModel)]="filtro.valor"
                           currencyMask 
                           name="valorTransferencia" 
                           placeholder="Valor" 
                           matInput maxlength="13"
                           [options]="{ prefix: '', thousands: '.', decimal: ',' }" />
                    <span matPrefix>R$&nbsp;</span>
                </mat-form-field>                
            </div>
            
            

            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;" fxFlexFill>
                <button mat-raised-button fxFlex="20%" (click)="consultar()">
                    CONSULTAR
                </button>

                <button mat-raised-button fxFlex="20%" style="padding-right: 20px" (click)="limpar()" route>
                    LIMPAR
                </button>
            </div>
        </form>

        <table [fxHide]="!mostrarTabela" matSort matSortDisableClear mat-table [dataSource]="dataSource" style="margin-top: 20px">

            <ng-container matColumnDef="origem">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="width: 30%;"> Origem </th>
                <td mat-cell *matCellDef="let element"> {{element.descContaOrigem}}  </td>
            </ng-container>

            <ng-container matColumnDef="destino">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="width: 30%;"> Destino </th>
                <td mat-cell *matCellDef="let element"> {{element.descContaDestino}} </td>
            </ng-container>
            
            <ng-container matColumnDef="dataDocumento">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="width: 15;"> Data Documento </th>
                <td mat-cell *matCellDef="let element"> {{ element.data | dataSimples }} </td>
            </ng-container>

            <ng-container matColumnDef="valorMovimentacao">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="width: 15;"> Valor </th>
                <td mat-cell *matCellDef="let element"> {{ element.valor | currency: 'BRL' }} </td>
            </ng-container>
            
            <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef> Ações </th>
                <td mat-cell *matCellDef="let element">
                    <button *ngIf="perfilAcesso.deleta"  mat-button (click)="deletar(element)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizar(element)">
                        <mat-icon>search</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div [hidden]="!mostrarTabela">
            <mat-paginator [pageSizeOptions]="[40, 60, 80, 100]" showFirstLastButtons></mat-paginator>
        </div>
        
        <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px"
                [fxHide]="mostrarTabela" >
            {{msg}}
        </div>

        <div fxLayout="row"  *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px"
            style="padding-top: 50px">
            <div>
                <button matTooltip="Adicionar nova transferência" mat-fab color="primary" [routerLink]="['/transferenciavalores/cadastrar']"
                    routerLinkActive="router-link-active">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>